import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import TablerWrapper from '@components/auntification/tablerWrapper';
import { AUTH_OFFSET_CONFIRM_CODE } from '@components/auntification/tablerWrapper/constants';
import { navigateTo, Alert, getParameterByName, isWeb } from '@helpers';
import Logo from '@components/logo/index';

import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import useStatusBar from '@components/common/useStatusBar';
import Loading from '@components/loading';
import { scale } from '@components/frame';

import { forgotPasswordCheckCode, forgotPassword, confirmInviteVerify } from '@reducers/user';

import CodeInput from '@components/codeInput';

const ConfirmCode = ({ route, C, forgotPasswordCheckCode, forgotPassword, confirmInviteVerify }) => {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  useStatusBar({ C });

  const isInviteScreen = route?.name === 'ConfirmInvite';

  // On web, read email/code directly from the URL to preserve the '+' character.
  // React Navigation's query-string parser converts '+' to space, corrupting email aliases like "user+1@domain.com".
  const urlEmail = isWeb ? getParameterByName('email') : null;
  const urlCode = isWeb ? getParameterByName('code') : null;
  const rawEmail = urlEmail || route?.params?.email;
  const rawCode = urlCode || route?.params?.code;

  const header = route?.params?.header;
  const message = route?.params?.message;
  const scenario = route?.params?.scenario || 'password';
  const data = route?.params?.data || {};
  const email = data.email || rawEmail;

  const onInput = async (text) => {
    setCode(text);
    if (text.length === 6) {
      await submit(text);
    }
  };

  useEffect(() => {
    if (rawEmail && rawCode) {
      confirmInviteVerify({ emailAddress: rawEmail, verificationCode: rawCode });
    }
  }, []);

  const submit = async (text) => {
    setLoading(true);
    switch (scenario) {
      case 'password': {
        await forgotPasswordCheckCode({ emailAddress: email, verificationCode: text }, () => {
          navigateTo('CreatePassword', { data: { code: text, email }, scenario: 'password' });
        });
        setLoading(false);
        return;
      }
    }
  };

  const sendCodeAgain = async () => {
    if (isInviteScreen) {
      await confirmInviteVerify({ emailAddress: route?.params?.email, verificationCode: route?.params?.code });
      Alert({ title: `Code was sent to ${email}.` });
    } else {
      await forgotPassword({ emailAddress: email }, () => Alert({ title: `Code was sent to ${email}.` }));
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <TablerWrapper offset={AUTH_OFFSET_CONFIRM_CODE}>
      <Logo {...{ isBack: true, title: header || i18n.t(isInviteScreen ? 'Verification code' : 'Reset code') }} />
      <View style={{ width: '100%', flexDirection: 'row', justifyContent: 'center', marginBottom: scale(18), marginTop: scale(34) }}>
        <View style={{ width: scale(143), flexDirection: 'row', justifyContent: 'center', marginRight: scale(20), position: 'relative' }}>
          <CodeInput {...{ count: 6, C, value: code, setValue: onInput }} />
        </View>
      </View>
      <Text
        style={[
          {
            color: C('Label/Light/Secondary'),
            textAlign: 'center',
          },
          font['Subhead 2'],
        ]}
      >
        {i18n.t(message || isInviteScreen ? 'A message with a code has been sent to' : 'A message with a reset code has been sent to')}
      </Text>
      <Text
        style={[
          {
            color: C('Label/Light/Secondary'),
            textAlign: 'center',
            marginTop: scale(10),
            marginBottom: scale(10),
          },
          font['Subhead 2'],
        ]}
      >
        {email}
      </Text>
      <Text
        style={[
          {
            color: C('Label/Light/Secondary'),
            textAlign: 'center',
          },
          font['Subhead 2'],
        ]}
      >
        {i18n.t('Enter the code to continue')}
      </Text>
      <TouchableOpacity
        style={{
          marginTop: scale(65),
        }}
        onPress={sendCodeAgain}
      >
        <Text style={[{ color: C('Label/Light/Secondary'), textAlign: 'center' }, font['Button 2']]}>
          {i18n.t(isInviteScreen ? 'Didn’t get a code?' : 'Didn’t get a reset code?')}
        </Text>
      </TouchableOpacity>
    </TablerWrapper>
  );
};

export default connect(null, { forgotPasswordCheckCode, forgotPassword, confirmInviteVerify })(ColorWrapper(ConfirmCode));
